import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import DraggableBarChart from './charts/DraggableBarChart';
import BaseFeature from './BaseFeature';
import { PERMANENT_SHUTDOWN } from '../../../../../../utils/constantFeatures';
import { Trans } from 'react-i18next';

class PermanentShutdown extends BaseFeature {
    constructor(props) {
        super(props);
        this.state = {
            ps_state: this.props.properties[PERMANENT_SHUTDOWN.channel].value,
            isEnabled: this.props.properties[PERMANENT_SHUTDOWN.channel].value === "1" ? true : false,
        };

        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };
        this.setState({ isEnabled: v === "1" ? true : false });

        this.props.handleChange(PERMANENT_SHUTDOWN.channel, v);
    }

    renderGraphText(){
        if(this.state.isEnabled){
            return (
                <h4 style={{textAlign: 'center', position: 'absolute', right: 100, top: 60, width: '400px'}}>
                    Warning: note that in case of driver overtemperature there is no power reduction and note that when the temperature exceed the driver thermal limit, it will shut down permanently.
                    <br/>
                    Driver can be reset only by T4T reprogramming.
                    <br/>
                    For detailed description see the Application Technical guide.
                </h4>
            );
        } else {
            return null;
        }
    }

    render() {

        return (
            <div>
                <div className="flex-row">
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            <Trans i18nKey="Permanent_Shut_Down" />
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertySwitch
                                property={{value:this.state.ps_state, info:{name:"dgps.en"}}}
                                title="Enable"
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>
                <div>
                    <Card className={super.getClassName(this.props.properties)}>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <DraggableBarChart
                                disabled={!this.state.isEnabled}
                                // containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                                properties={this.props.properties}
                                x={{ 'title': 'Temperature (°C)' }}
                                y={{ 'title': 'Output Level (%)' }}
                                tickValues={{ x: [], y: [] }}
                                xThresholds={[
                                    { value: 0, color: 'rgb(0,0,0)' },
                                ]}
                                xLabels={this.getXLabels()}
                                yLabels={this.getYLabels()}
                                // handleChange={this.handleChartChange}
                            />
                            {this.renderGraphText()}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }

    getXLabels() {
        const labels = [];
        const smallLabels = [];
        const ticks = [];

        ticks.push(0);
        labels.push({ label: 'Tdriver max', x: 0 });

        return { labels: labels, smallLabels: smallLabels, ticks: ticks };
    }

    getYLabels() {
        const labels = {};
        const max = 100;
        if (!labels[max]) {
            labels[max] = { label: max, y: max };
        }
        return Object.keys(labels).map((key) => { return labels[key]; });
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(PermanentShutdown);
